var parent = require('../../es/instance/find');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/find.js
// module id = 470
// module chunks = 0 1